import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { AssessmentList } from 'Components/assessments/AssessmentList'
import { useAuthTenant } from 'store/auth'
import { Main as Container } from 'Components/Main'
import { PageHeader } from 'Components/ui'

const BLUE  = 'var(--vo-celeste)';

const GenerateBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  height: 40px;
  padding: 0 18px;
  background: ${BLUE};
  color: white;
  border: none;
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover { background: var(--vo-cobalto); }
`

export const AssessmentsPage = () => {
  const { t } = useTranslation(['gap-analysis'])
  const navigate = useNavigate()
  const selectedTenant = useSelector(useAuthTenant)

  return (
    <Container>
      <PageHeader
        title={t('gap-analysis:assessment.page.title')}
        segments={[
          { label: t('common:breadcrumbs.thirdPartyRiskManagement') },
          { label: t('gap-analysis:assessment.page.title') },
        ]}
        actions={
          <GenerateBtn onClick={() => navigate('/vendor-assessments/new')}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            {t('gap-analysis:assessment.page.generateButton')}
          </GenerateBtn>
        }
      />

      <AssessmentList tenant={selectedTenant?.slug} />
    </Container>
  )
}
